import { render, staticRenderFns } from "./TransfersDrivers.vue?vue&type=template&id=392ec0fd&"
import script from "./TransfersDrivers.vue?vue&type=script&lang=js&"
export * from "./TransfersDrivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392ec0fd')) {
      api.createRecord('392ec0fd', component.options)
    } else {
      api.reload('392ec0fd', component.options)
    }
    module.hot.accept("./TransfersDrivers.vue?vue&type=template&id=392ec0fd&", function () {
      api.rerender('392ec0fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TransfersDrivers.vue"
export default component.exports